import { CloseOutlined } from '@ant-design/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { useBannerPreferences } from '../../hooks/use_banner_preferences';
import { BannerKeys } from '../../redux/banner_preferences';
import { getExperimentUuid } from '../../redux/user';
import { OmniaLinkButton } from '../omnia_button/omnia_link_button';
import appIcon from './app_icon.webp';

export const BannerCatalog = () => {
  const { isBannerHidden, setBannerPreferencesHidden } = useBannerPreferences();
  const bannerKey = BannerKeys.CATALOG;
  const hidden = isBannerHidden(bannerKey);
  const experimentUuid = useSelector(getExperimentUuid);
  const appUrl = `https://go.omniafishing.com/gZRj/y23rdywj?anonymous_id=${experimentUuid}`;

  if (hidden) {
    return null;
  }

  return (
    <div className="fixed bg-[#002b3a] text-white bottom-0 left-0 right-0 p-3 pl-0 flex items-center justify-between z-[1000] gap-3 shadow shadow-black/20">
      <div
        className="p-3 -mr-3 opacity-50 flex-grow-0 flex-shrink-0"
        onClick={() => setBannerPreferencesHidden(bannerKey)}
        role="button"
        aria-label="Close banner"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setBannerPreferencesHidden(bannerKey);
          }
        }}
      >
        <CloseOutlined />
      </div>
      <div className="w-10 flex-grow-0 flex-shrink-0 rounded-xl overflow-hidden">
        <a href={appUrl}>
          <img src={appIcon} alt="Omnia Fishing App Icon" />
        </a>
      </div>
      <div>
        <p className="uppercase font-bold leading-tight">SHOP TACKLE FASTER</p>
        <p className="text-xs">Our free app is an even better shopping experience</p>
      </div>
      <div className="flex-grow-0 flex-shrink-0">
        <OmniaLinkButton size="md" kind="primary" to={appUrl}>
          GET
        </OmniaLinkButton>
      </div>
    </div>
  );
};
